import React from 'react';
import ReactDOM from 'react-dom';

import { ProfileACL } from '@profile/utils/ProfileACL';
import './index.scss';
import '@profile_common/index.scss';

import App from './App';

document.addEventListener('DOMContentLoaded', () => {
  const profileElem = document.getElementById('profile-root');
  const {
    performance,
    social_profiles: socialProfiles,
    topic_problem_stats: topicStats,
    user_details: userDetails,
    render_type: renderType,
  } = JSON.parse(profileElem.getAttribute('profile_data'));

  const profileACL = new ProfileACL(renderType, userDetails);

  ReactDOM.render(
    <App
      performance={performance}
      socialProfiles={socialProfiles}
      topicStats={topicStats}
      userDetails={userDetails}
      profileACL={profileACL}
    />, document.getElementById('profile-root'),
  );
});

// Currently only works with CSS
// Add this for HMR to work
if (process.env.NODE_ENV === 'development') {
  module.hot.accept();
}
